var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { PureComponent } from 'react';
import * as PropTypes from 'prop-types';
import { formatImageAblur } from '@ifeng-fe/public_method';
import { getImageUrl, haveImage } from '../../utils/newsStream';
import { formatTime, classNames, styleName } from '../../utils/utils';
var ThreeImage = /** @class */ (function (_super) {
    __extends(ThreeImage, _super);
    function ThreeImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThreeImage.prototype.render = function () {
        var _a = this.props, thumbnails = _a.thumbnails, item = _a.item, url = _a.url, pinglunUrl = _a.pinglunUrl, isDisplaySource = _a.isDisplaySource, isCount = _a.isCount, countMapCache = _a.countMapCache, cutImage = _a.cutImage, searchPathMap = _a.searchPathMap;
        var image = (thumbnails && haveImage(thumbnails)) ? thumbnails.image : undefined;
        var isSource = isDisplaySource && !!item.source && item.source !== '';
        var width = cutImage && cutImage.threeImage ? cutImage.threeImage.width : 203;
        var height = cutImage && cutImage.threeImage ? cutImage.threeImage.height : 130;
        return (React.createElement("li", { className: classNames(styleName('newsStream-news-item-3-image'), 'clearfix', 'news_item'), "data-id": item.id },
            React.createElement("h2", { className: classNames(styleName('newsStream-news-item-title'), styleName('newsStream-mb16')) },
                React.createElement("a", { href: url, title: item.title, target: "_blank", dangerouslySetInnerHTML: { __html: item.title } })),
            React.createElement("a", { className: classNames(styleName('newsStream-image-link-3'), styleName('newsStream-mr11')), href: url, title: item.title, target: "_blank" },
                React.createElement("img", { src: image ? formatImageAblur(getImageUrl(image[0]), width, height) : undefined, alt: item.title, width: width, height: height })),
            React.createElement("a", { className: classNames(styleName('newsStream-image-link-3'), styleName('newsStream-mr11')), href: url, title: item.title, target: "_blank" },
                React.createElement("img", { src: image ? formatImageAblur(getImageUrl(image[1]), width, height) : undefined, alt: item.title, width: width, height: height })),
            React.createElement("a", { className: styleName('newsStream-image-link-3'), href: url, title: item.title, target: "_blank" },
                React.createElement("img", { src: image ? formatImageAblur(getImageUrl(image[2]), width, height) : undefined, alt: item.title, width: width, height: height })),
            React.createElement("div", { className: classNames(styleName('newsStream-top11'), styleName('newsStream-news-item-infor'), 'clearfix') },
                item.searchPath && searchPathMap[item.searchPath] ? (React.createElement("span", { className: classNames(styleName('newsStream-mr10'), styleName('newsStream-text'), styleName('newsStream-searchPath')) }, searchPathMap[item.searchPath])) : null,
                isSource ? (React.createElement("span", { className: classNames(styleName('newsStream-mr10'), styleName('newsStream-text')) }, item.source)) : null,
                item.newsTime ? (React.createElement("time", { className: styleName('newsStream-text') }, formatTime(item.newsTime))) : null,
                isCount ? (React.createElement("a", { className: classNames(styleName('newsStream-ly'), 'ly'), id: "count" + item.id, href: pinglunUrl, target: "_blank" }, ((item.commentUrl || item.guid) && countMapCache && countMapCache[item.id]) || 0)) : null)));
    };
    ThreeImage.propTypes = {
        thumbnails: PropTypes.object,
        item: PropTypes.object,
        url: PropTypes.string,
        pinglunUrl: PropTypes.string,
        isDisplaySource: PropTypes.bool
    };
    return ThreeImage;
}(PureComponent));
export default ThreeImage;
